var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47656 12.4139C3.42188 13.2999 3.07031 15.9296 3.07031 15.9296C3.07031 15.9296 5.7 15.578 6.58594 14.5233C7.08516 13.9327 7.07812 13.0257 6.52266 12.4772C6.24936 12.2164 5.88935 12.0656 5.51172 12.054C5.1341 12.0423 4.76546 12.1705 4.47656 12.4139Z",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.3595L7.64062 9.25018C8.01479 8.27946 8.48592 7.34897 9.04688 6.47283C9.86614 5.1629 11.0069 4.08435 12.3607 3.33977C13.7145 2.59519 15.2362 2.20934 16.7812 2.21892C16.7812 4.13142 16.2328 7.49236 12.5625 9.9533C11.6744 10.5149 10.7322 10.986 9.75 11.3595Z",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 9.2501H4.125C4.125 9.2501 4.51172 7.11963 5.53125 6.4376C6.67031 5.67822 9.04688 6.4376 9.04688 6.4376",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.3594V14.875C9.75 14.875 11.8805 14.4883 12.5625 13.4688C13.3219 12.3297 12.5625 9.95312 12.5625 9.95312",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartup1);
export default __webpack_public_path__ + "static/media/startup1.dd061600b6fb9900ef160e373ec4a992.svg";
export { ForwardRef as ReactComponent };